module.exports = __webpack_public_path__ + "static/img/down_img03.png.207d5ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sptj/down_img03.png.png
// module id = Su05
// module chunks = 1